import { DefaultComponentStyler } from "@/components/default-component-styler";

const BaseComponent = {
  name: "BaseComponent",
  mixins: [DefaultComponentStyler],
  methods: {
    hasScopedSlot(name = "default") {
      return !!this.$scopedSlots[name];
    },
  },
};
export { BaseComponent };
export default { BaseComponent };
